import conf from '../config';
import { getOrganization } from './users';
import queryString from 'query-string';

const SET_RENDERS = 'SET_RENDERS';
const SET_RENDER = 'SET_RENDER';
const SET_RENDER_RESULTS = 'SET_RENDER_RESULTS';
const SET_RENAME_IMAGES = 'SET_RENAME_IMAGES';
const SET_EXPORT_JOBS = 'SET_EXPORT_JOBS';
const DELETE_JOB = 'DELETE_JOB';
const SET_SEARCH_RENDERS = 'SET_SEARCH_RENDERS';
const CLEAR_DATA = 'CLEAR_DATA';

const initialState = {
  renders: {},
  searchedRenders: {},
  results: {},
  numbers: {},
  renameImages: {},
  exportSpreadsheets: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_RENDERS:
      const renders = action.payload.reduce((acc, el) => {
        acc[el._id] = el;
        return acc;
      }, {});
      return { ...state, renders };
    case SET_RENDER:
      const oldRenders = state.renders;
      oldRenders[action.payload._id] = action.payload;
      return { ...state, renders: oldRenders };
    case SET_RENDER_RESULTS:
      const results = state.results;
      const numbers = state.numbers;
      if (results[action.payload.id]) {
        const newResults = [
          ...results[action.payload.id],
          ...action.payload.results,
        ];
        results[action.payload.id] = newResults;
      } else {
        results[action.payload.id] = action.payload.results;
        numbers[action.payload.id] = action.payload.number;
      }
      return { ...state, results, numbers };
    case SET_RENAME_IMAGES:
      return { ...state, renameImages: action.payload };
    case SET_EXPORT_JOBS:
      return { ...state, exportSpreadsheets: action.payload };
    case DELETE_JOB:
      const renderState = state.renders;
      delete renderState[action.payload];
      return { ...state, renders: renderState };
    case SET_SEARCH_RENDERS:
      const searchedRenders = action.payload.reduce((acc, el) => {
        acc[el._id] = el;
        return acc;
      }, {});
      return { ...state, searchedRenders };
    case CLEAR_DATA:
      return initialState;
    default:
      return state;
  }
};

export const getRenders = (state) => Object.values(state.jobs.renders);

export const getResults = (state, id) => state.jobs.results[id];

export const getNumbers = (state, id) => state.jobs.numbers[id];

export const getSearchedRenders = (state) =>
  Object.values(state.jobs.searchedRenders);

export const createJob = (model, data) => async (dispatch, getState) => {
  const form = new FormData();
  const state = getState();
  const organization = getOrganization(state);
  if (data) {
    form.append('file', data);
  }
  for (let i in model) {
    if (typeof model[i] === 'object') {
      form.append(i, JSON.stringify(model[i]));
    } else {
      form.append(i, model[i]);
    }
  }
  form.append('organization', organization && organization.slug);
  const result = await fetch(`${conf.apiRoot}/api/jobs`, {
    method: 'POST',
    credentials: 'include',
    body: form,
  }).then((res) => {
    if (res.status >= 500) return null;
    if (model.type === 'batch-download') return res.blob();
    return res.json();
  });
  return result;
};

const setRenders = (renders) => ({ type: SET_RENDERS, payload: renders });

const setRender = (render) => ({ type: SET_RENDER, payload: render });

const setRenderResults = (id, number, results) => ({
  type: SET_RENDER_RESULTS,
  payload: { id, number, results },
});

export const fetchJobs = (query = {}) => async (dispatch, getState) => {
  const state = getState();
  const organization = getOrganization(state);
  query.organization = organization && organization.slug;
  console.log(query);
  const result = await fetch(
    `${conf.apiRoot}/api/jobs?${queryString.stringify(query)} `,
    {
      credentials: 'include',
    }
  ).then((res) => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (result) {
    if (query.name) {
      dispatch(setSearchJobs(result));
    } else {
      dispatch(setRenders(result));
    }
  }
  return result;
};

export const getJob = (id) => async (dispatch, getState) => {
  const state = getState();
  const renders = getRenders(state);
  if (renders.length > 0) {
    const render = renders.find((item) => item._id === id);
    return render;
  }
  const result = await fetch(`${conf.apiRoot}/api/jobs/${id}`, {
    credentials: 'include',
  }).then((res) => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (result) dispatch(setRender(result));
  return result;
};

export const exportImage = (id) => async (dispatch) => {
  const result = await fetch(
    `${conf.apiRoot}/api/jobs/${id}/export?type=image`,
    {
      credentials: 'include',
    }
  ).then((res) => {
    if (res.status === 200) {
      return res.blob();
    }
    return res.json();
  });
  if (result && result.status === 'failed') return result;
  const dlink = document.createElement('a');
  dlink.download = `${id}.zip`;
  dlink.href = URL.createObjectURL(result);
  dlink.click();
};

export const getJobResults = (id, query = { page: 0 }) => async (
  dispatch,
  getState
) => {
  const state = getState();
  const currentImages = state.jobs.results[id];
  if (currentImages && currentImages.length > query.page * 24 && !query.all)
    return;
  const results = await fetch(
    `${conf.apiRoot}/api/jobs/${id}/results?${queryString.stringify(query)}`,
    {
      credentials: 'include',
    }
  ).then((res) => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (results) {
    const number = results.number;
    const images = results.results;
    console.log('2222222222', images);
    dispatch(setRenderResults(id, number, images));
    return images;
  }
};

export const upload = (options = {}) => async (dispatch) => {
  options.type = 'upload';
  options.uploadType = 'rename';
  const body = JSON.stringify(options);
  const result = await fetch(`${conf.apiRoot}/api/jobs`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body,
  }).then((res) => {
    if (res.status === 200) return res.json();
    return null;
  });
};

export const uploadScene7 = (id) => async (dispatch) => {
  const result = await fetch(`${conf.apiRoot}/api/jobs/${id}/upload`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ renderId: id, type: 'upload' }),
  }).then((res) => {
    if (res.status === 200) return res.json();
    return null;
  });
};

export const exportSpreadsheet = () => async (dispatch, getState) => {
  const state = getState();
  const organization = getOrganization(state);
  const result = await fetch(
    `${conf.apiRoot}/api/jobs/export?organization=${
      organization && organization.slug
    }`,
    {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({ type: 'excel' }),
    }
  ).then((res) => {
    if (res.status === 200) return res.blob();
    return null;
  });
  return result;
};

export const getRenameImages = (state) => state.jobs.renameImages;

const setRenameImages = (images) => ({
  type: SET_RENAME_IMAGES,
  payload: images,
});

export const fetchRenameImages = (attrs) => async (dispatch, getState) => {
  const state = getState();
  const organization = getOrganization(state);
  attrs.organization = organization && organization.slug;
  const result = await fetch(
    `${conf.apiRoot}/api/jobs/rename?${queryString.stringify(attrs)}`,
    {
      credentials: 'include',
    }
  ).then((res) => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (result) {
    dispatch(setRenameImages(result));
  }
  return result;
};

export const getExportJobs = (state) => state.jobs.exportSpreadsheets;

export const setExportJobs = (jobs) => ({
  type: SET_EXPORT_JOBS,
  payload: jobs,
});

export const fetchExportJobs = (type) => async (dispatch, getState) => {
  const state = getState();
  const organization = getOrganization(state);
  const result = await fetch(
    `${conf.apiRoot}/api/jobs?organization=${
      organization && organization.slug
    }&type=${type}`,
    {
      credentials: 'include',
    }
  ).then((res) => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (result) dispatch(setExportJobs(result));
  return result;
};

export const downloadExportJob = (id) => async (dispatch, getState) => {
  const state = getState();
  const organization = getOrganization(state);
  const result = await fetch(
    `${conf.apiRoot}/api/jobs/${id}/download?organization=${
      organization && organization.slug
    }`,
    {
      credentials: 'include',
    }
  ).then((res) => {
    console.log(res.status);
    if (res.status === 200) return res.blob();
    return null;
  });
  return result;
};

export const deleteJob = (id) => async (dispatch, getState) => {
  const state = getState();
  const organization = getOrganization(state);
  const result = await fetch(
    `${conf.apiRoot}/api/jobs/${id}?organization=${
      organization && organization.slug
    }`,
    {
      method: 'DELETE',
      credentials: 'include',
    }
  ).then((res) => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (result) {
    dispatch(deleteJobFromState(id));
  }
  return result;
};

const deleteJobFromState = (id) => ({ type: DELETE_JOB, payload: id });

const setSearchJobs = (renders) => ({
  type: SET_SEARCH_RENDERS,
  payload: renders,
});



// WEBPACK FOOTER //
// ./src/modules/jobs.js